var submenu = {
	$this: $( '.js-submenu' )
};

submenu.init = function() {
	$( '.js-submenu .menu-item-has-children .icon' ).on( 'click', function() {
		let $this = $(this);
		let $item = $this.parent('.menu-item-has-children');
		let subMenuHeight = $item.find('ul.sub-menu').outerHeight( true );

		if ($item.hasClass('show')) {
			$item.find('.sub-menu-outer').css('max-height', 0);
			$item.removeClass('show');
		} else {
			$item.find('.sub-menu-outer').css('max-height', subMenuHeight + 'px');
			$item.addClass('show');
		}
	});

	$('.js-submenu .current-menu-item .icon').click();
}


export { submenu };
